import React from 'react';

// const FOUR_UP_FORMATS = ["webp", "jpeg"];
const FOUR_UP_FORMATS = ['jpeg'];
const FOUR_UP_SRCSET = ['large 512w', 'medium 400w', 'small 272w'];
const FOUR_UP_QUERIES = ['(min-width: 80rem)', '(min-width: 37.5rem)', ''];

const getFourUpSources = (originalURL: string) => {
  if (!originalURL || originalURL.indexOf('media_asset/') === -1) {
    return [];
  }

  const baseURL = originalURL.slice(0, originalURL.indexOf('media_asset/') + 12);
  const result: any = [];

  FOUR_UP_FORMATS.forEach((format) => {
    FOUR_UP_SRCSET.forEach((source, sourceIndex) => {
      result.push(
        <source
          media={FOUR_UP_QUERIES[sourceIndex]}
          srcSet={`${baseURL}${format}_${source}`}
          type={`image/${format}`}
        />
      );
    });
  });

  return result;
};

export { getFourUpSources };

export default getFourUpSources;
